module.exports = __webpack_public_path__ + "static/media/saude.3fe86b96.png";